import React from "react"
import Bowser from "bowser"

import { ImgFluid, Img400pxMaxFluid } from "../"
import AfterDropBottle from "../../assets/video/after_drop_bottle.mp4"
import RivellaWavesLeft from "../../assets/video/rivella_waves_left.mp4"
import RivellaWavesRight from "../../assets/video/rivella_waves_right.mp4"
import RivellaDroplets from "../../assets/video/rivella_droplets.mp4"
import s from "./MainPageVideoBottle.module.scss"
import { checkClipPathSupport } from "../../helper"

// static and depends on svg in clipPath
const svgDefaultWidth = 1001,
  svgDefaultHeight = 2112

const maskBias = {
  desktop: { x: 1, y: 0.982 },
  laptop: { x: 1, y: 0.98 },
  tablet: { x: 1, y: 0.97 },
  mobile: { x: 1, y: 0.97 },
}

const INITIAL_DROP_VIDEO_LENGTH = 5000

class MainPageVideoBottle extends React.Component {
  constructor(props) {
    super(props)
    this.initialDropVideo = React.createRef()
    this.moveLeftVideo = React.createRef()
    this.moveRightVideo = React.createRef()
    this.idleVideo = React.createRef()
    this.wrapper = React.createRef()
    const uniqueId = "_" + (Math.random() * 10000000).toFixed(0)
    this.state = {
      svgScale: {
        x: 0,
        y: 0,
      },
      browserDoesntSupport: false,
      uniqueId,
      videosBegun: false,
      initialVideoPlayCompleted: false,
    }
    this.intervalCount = 0
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      const supports = checkClipPathSupport(window, Bowser)
      if (!supports) {
        return this.setState({
          browserDoesntSupport: true,
        })
      }
    }
    const initialDropVideo = this.initialDropVideo.current
    // video.playbackRate = 0.7
    if (
      initialDropVideo &&
      window.matchMedia("(prefers-reduced-motion)").matches
    ) {
      initialDropVideo.removeAttribute("autoplay")
      initialDropVideo.pause()
    }
    this.calcSvgScale()
    this.updateInterval = setInterval(() => {
      this.calcSvgScale()
      if (++this.intervalCount > 10) clearInterval(this.updateInterval)
    }, 300)
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.calcSvgScale)
    }
  }
  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.calcSvgScale)
    }
    clearInterval(this.updateInterval)
  }

  componentDidUpdate(prevProps) {
    if (this.props.recalcMaskSignal) {
      setTimeout(() => {
        this.calcSvgScale()
      }, 50)
    }
    if (
      !!this.props.currentVideo &&
      !prevProps.currentVideo &&
      !this.state.videosBegun
    ) {
      this.startVideos()
    }
    if (
      prevProps.currentVideo !== this.props.currentVideo &&
      this.state.videosBegun
    ) {
      this.controlVideosVisibility(this.props.currentVideo)
    }
  }

  startVideos = () => {
    this.setState(
      {
        videosBegun: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            initialVideoPlayCompleted: true,
          })
        }, INITIAL_DROP_VIDEO_LENGTH - 100)
      }
    )
  }

  controlVideosVisibility = (videoName) => {
    const { videosBegun, initialVideoPlayCompleted } = this.state
    if (videosBegun && !this.state.browserDoesntSupport) {
      const initialDropVideo = this.initialDropVideo.current
      if (!initialVideoPlayCompleted) {
        setTimeout(() => {
          initialDropVideo.style.opacity = 0
          initialDropVideo.style.visibility = 0
          this.setState({
            initialVideoPlayCompleted: true,
          })
        }, INITIAL_DROP_VIDEO_LENGTH - 2000)
      } else {
        const moveLeftVideo = this.moveLeftVideo.current
        const moveRightVideo = this.moveRightVideo.current
        const idleVideo = this.idleVideo.current

        // if videos are not rendered yet
        if (
          !initialDropVideo ||
          !moveLeftVideo ||
          !moveRightVideo ||
          !idleVideo
        )
          return

        initialDropVideo.style.opacity = 0
        initialDropVideo.style.visibility = 0

        moveLeftVideo.style.opacity = 0
        moveLeftVideo.style.visibility = "hidden"
        moveLeftVideo.currentTime = 0
        moveLeftVideo.pause()

        moveRightVideo.style.opacity = 0
        moveRightVideo.style.visibility = "hidden"
        moveRightVideo.currentTime = 0
        moveRightVideo.pause()

        // idleVideo.style.opacity = 0
        // idleVideo.style.visibility = "hidden"

        if (videoName === "moveLeft") {
          moveLeftVideo.style.opacity = 1
          moveLeftVideo.style.visibility = "visible"
          moveLeftVideo.play()
        }
        if (videoName === "moveRight") {
          moveRightVideo.style.opacity = 1
          moveRightVideo.style.visibility = "visible"
          moveRightVideo.play()
        }
        if (videoName === "idle") {
          idleVideo.style.opacity = 1
          idleVideo.style.visibility = "visible"
        }
      }
    }
    // const initialDropVideo = this.initialDropVideo.current
    // const moveLeftVideo = this.moveLeftVideo.current
    // const moveRightVideo = this.moveRightVideo.current
    // const idleVideo = this.idleVideo.current
  }

  handleWhichVideosToRender = (/*videoName*/) => {
    let objToReturn = null
    if (!this.state.videosBegun || this.state.browserDoesntSupport) {
      return objToReturn
    }
    // if (videoName === "initialDrop") {
    //   objToReturn = (
    //     <>
    //       <video
    //         key="afterdrop"
    //         className={s.AfterDrop}
    //         width={"100%"}
    //         ref={this.initialDropVideo}
    //         src={AfterDropBottle}
    //         muted
    //         autoPlay
    //         playsInline
    //       />
    //       <video
    //         key="idlevideo"
    //         className={s.IdleVideo}
    //         width={"100%"}
    //         ref={this.idleVideo}
    //         src={RivellaDroplets}
    //         loop
    //         autoPlay
    //         muted
    //         playsInline
    //       />
    //     </>
    //   )
    // } else {
    objToReturn = (
      <>
        <video
          key="afterdrop"
          className={s.AfterDrop}
          width={"100%"}
          ref={this.initialDropVideo}
          src={AfterDropBottle}
          muted
          autoPlay
          playsInline
          disablePictureInPicture
          loading="auto"
        />
        <video
          className={s.WavesLeft}
          width={"100%"}
          ref={this.moveLeftVideo}
          src={RivellaWavesLeft}
          muted
          playsInline
          disablePictureInPicture
          loading="metadata"
        />
        <video
          className={s.WavesRight}
          width={"100%"}
          ref={this.moveRightVideo}
          src={RivellaWavesRight}
          muted
          playsInline
          disablePictureInPicture
          loading="metadata"
        />
        <video
          key="idlevideo"
          className={s.IdleVideo}
          width={"100%"}
          ref={this.idleVideo}
          src={RivellaDroplets}
          loop
          autoPlay
          muted
          playsInline
          disablePictureInPicture
          loading="auto"
        />
      </>
    )
    // }
    return objToReturn
  }

  calcSvgScale = () => {
    const wrapper = this.wrapper.current
    // const { x, y } = this.svgScale
    const { x, y } = this.state.svgScale
    const { innerWidth } = window
    if (wrapper) {
      let deviceBias = maskBias.desktop
      if (innerWidth < 600) deviceBias = maskBias.mobile
      else if (innerWidth < 1100) deviceBias = maskBias.tablet
      else if (innerWidth < 1500) deviceBias = maskBias.laptop
      const nextX = wrapper.clientWidth / svgDefaultWidth
      const nextY = wrapper.clientHeight / svgDefaultHeight
      if (x !== nextX || y !== nextY || this.props.recalcMaskSignal) {
        this.setState({
          svgScale: {
            x: (wrapper.clientWidth / svgDefaultWidth) * deviceBias.x,
            y: (wrapper.clientHeight / svgDefaultHeight) * deviceBias.y,
          },
        })
      }
    }
  }

  render() {
    const { imageName, currentVideo } = this.props
    const { x, y } = this.state.svgScale
    return (
      <>
        <div
          className={s.Wrapper}
          ref={this.wrapper}
          style={{
            WebkitClipPath: !this.state.browserDoesntSupport
              ? `url(#${this.state.uniqueId})`
              : null,
            clipPath: !this.state.browserDoesntSupport
              ? `url(#${this.state.uniqueId})`
              : null,
          }}
        >
          {this.handleWhichVideosToRender(currentVideo)}
          {/* <video
          className={s.AfterDrop}
          width={"100%"}
          ref={this.video}
          src={AfterDropBottle}
          loop
          autoPlay
          muted
        /> */}
          <div className={s.BottleWrapper}>
            <Img400pxMaxFluid fileName={imageName} />
          </div>
          {/* used by other components to give overlay over with global classname */}
          <div className="custom_overlay"></div>

          <svg width="0" height="0">
            <defs>
              <clipPath id={this.state.uniqueId}>
                <path
                  style={{ transform: `scale(${x}, ${y})` }}
                  d="M 286.609375 20.605469 C 308 0 414.945312 0 498.359375 0 C 718.667969 0 714.390625 14.164062 720.804688 39.921875 C 725.9375 60.527344 727.222656 109.464844 727.222656 131.355469 L 720.804688 131.355469 L 720.804688 184.15625 C 720.804688 185.445312 718.667969 188.019531 714.390625 188.019531 C 710.964844 188.019531 701.554688 189.738281 697.277344 190.59375 C 714.390625 198.320312 750.75 203.730469 750.75 209.914062 C 750.75 216.09375 714.390625 215.0625 697.277344 216.351562 C 697.277344 244.683594 701.984375 295.164062 703.695312 301.347656 C 705.832031 309.074219 780.695312 350.28125 804.222656 374.75 C 881.222656 446.867188 909.027344 477.777344 938.972656 531.863281 C 968.917969 585.953125 988.167969 658.066406 988.167969 667.082031 C 988.167969 676.097656 979.609375 681.25 979.609375 692.839844 C 979.609375 704.429688 992.445312 712.15625 992.445312 718.59375 C 992.445312 725.035156 983.890625 731.472656 983.890625 739.199219 C 983.890625 746.925781 996.722656 755.941406 996.722656 762.378906 C 996.722656 768.820312 986.027344 772.683594 986.027344 782.984375 C 986.027344 793.289062 994.582031 797.152344 994.582031 810.027344 C 994.582031 822.90625 981.75 825.484375 981.75 835.785156 C 981.75 846.085938 988.167969 846.085938 988.167969 858.964844 C 988.167969 871.84375 968.917969 887.296875 968.917969 892.449219 C 968.917969 897.601562 977.472656 909.191406 977.472656 916.917969 C 977.472656 924.644531 958.222656 946.535156 958.222656 952.976562 C 958.222656 959.414062 966.777344 976.15625 964.640625 982.59375 C 962.5 989.035156 947.527344 1010.925781 947.527344 1017.367188 C 947.527344 1023.804688 958.222656 1043.121094 958.222656 1049.5625 C 958.222656 1056 941.109375 1070.164062 941.109375 1086.90625 C 941.109375 1103.648438 951.804688 1108.800781 951.804688 1116.527344 L 951.804688 1705.054688 C 977.472656 1766.867188 983.890625 1809.367188 988.167969 1838.984375 C 992.445312 1868.605469 998.859375 1943.296875 998.859375 1976.78125 C 998.859375 2010.261719 962.5 2055.335938 941.109375 2074.652344 C 919.722656 2093.972656 864.109375 2105.5625 832.027344 2105.5625 C 806.359375 2105.5625 761.445312 2096.976562 742.195312 2092.683594 C 714.816406 2094.742188 648.082031 2090.964844 618.140625 2088.820312 C 592.472656 2102.984375 553.972656 2110.710938 545.417969 2110.710938 L 474.832031 2110.710938 C 433.765625 2110.710938 397.832031 2097.835938 385 2091.394531 C 374.304688 2095.257812 297.304688 2092.683594 273.777344 2092.683594 C 250.25 2092.683594 220.304688 2100.410156 203.195312 2102.984375 C 186.082031 2105.5625 124.054688 2106.847656 94.109375 2093.972656 C -23.527344 2046.320312 2.136719 1921.40625 6.414062 1876.332031 C 9.839844 1840.273438 34.933594 1739.394531 47.054688 1693.464844 L 47.054688 1115.238281 C 51.332031 1108.800781 59.886719 1090.769531 59.886719 1079.179688 C 59.886719 1067.589844 42.777344 1061.152344 42.777344 1046.984375 C 42.777344 1032.820312 53.472656 1027.667969 53.472656 1016.078125 C 53.472656 1004.488281 29.945312 983.882812 34.222656 976.15625 C 38.5 968.429688 40.636719 956.839844 40.636719 947.824219 C 40.636719 938.808594 19.25 923.355469 23.527344 916.917969 C 27.804688 910.476562 27.804688 891.160156 27.804688 884.722656 C 27.804688 878.28125 10.695312 869.269531 10.695312 861.542969 C 10.695312 853.816406 19.25 847.375 19.25 837.074219 C 19.25 826.769531 4.277344 816.46875 4.277344 810.027344 C 4.277344 803.589844 14.972656 794.574219 14.972656 785.5625 C 14.972656 776.546875 4.277344 768.820312 4.277344 761.09375 C 4.277344 753.367188 17.109375 745.640625 17.109375 737.914062 C 17.109375 730.183594 8.554688 725.035156 8.554688 717.308594 C 8.554688 709.582031 21.386719 703.140625 21.386719 692.839844 C 21.386719 682.535156 14.972656 679.960938 14.972656 669.660156 C 14.972656 659.355469 14.972656 624.585938 47.054688 557.621094 C 79.136719 490.652344 130.472656 435.277344 149.722656 414.671875 C 168.972656 394.066406 280.195312 318.085938 290.886719 302.632812 C 299.445312 290.269531 303.722656 240.820312 303.722656 217.640625 C 286.609375 216.351562 250.25 216.09375 250.25 209.914062 C 250.25 202.183594 293.027344 194.457031 297.304688 194.457031 C 300.726562 194.457031 300.15625 191.023438 299.445312 189.308594 C 294.308594 189.308594 284.472656 187.589844 280.195312 186.730469 L 280.195312 139.082031 C 280.195312 134.960938 274.488281 131.355469 271.636719 130.066406 C 269.5 100.449219 269.5 37.089844 286.609375 20.605469 Z M 286.609375 20.605469"
                  fill="black"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className={s.Shadow}>
          {/* <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className={s.InnerCircle}>
            <circle cx="50" cy="50" r="50" />
          </svg> */}
          {/* <div className={s.InnerCircle}></div> */}
          {/* <div className={s.BottleWrapper}>
            <ImgFluid fileName={imageName} />
          </div> */}
          <div className={s.ShadowWrapper}>
            <ImgFluid fileName={"bottle_shadow.png"} loading="eager" />
          </div>
        </div>
      </>
    )
  }
}

export default MainPageVideoBottle
